import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n)=>{let{data:r}=await t.put(`/roles/scope`,{...n,scope:e(n.scope)});return r};export{t as updateScopeRole};
//# sourceMappingURL=update-scope-role.mjs.map